import moment from 'moment';
import { DATE_FORMAT } from 'constants/app-constants';
import { COLUMN_VALIDATIONS } from './constants';

// Validate individual cell value
export const validateCell = (column, value, row) => {
	const validation = COLUMN_VALIDATIONS[column];
	if (!validation) return null;

	// Check if empty
	const isEmpty = value === null || value === undefined || String(value).trim() === '';

	// Check required
	if (validation.required && isEmpty) {
		return validation.message || `${column} is required`;
	}

	// Skip validation if not required and empty
	if (!validation.required && isEmpty) {
		return null;
	}

	// Type validation
	if (validation.type === 'number') {
		const num = Number(value);
		if (isNaN(num)) {
			return `${column} must be a valid number`;
		}
		if (validation.min !== undefined && num < validation.min) {
			return validation.message || `${column} must be at least ${validation.min}`;
		}
		if (validation.max !== undefined && num > validation.max) {
			return validation.message || `${column} must be at most ${validation.max}`;
		}
	}

	// Date validation
	if (validation.type === 'date') {
		if (!moment(value, DATE_FORMAT.DD_MM_YYYY, true).isValid()) {
			return 'Invalid date format. Use DD-MM-YYYY';
		}
	}

	// Pattern validation
	if (validation.pattern && !validation.pattern.test(String(value))) {
		return validation.message || `${column} format is invalid`;
	}

	// Enum validation
	if (validation.enum && !validation.enum.includes(String(value).toLowerCase())) {
		return validation.message || `${column} must be one of: ${validation.enum.join(', ')}`;
	}

	// String length validation
	if (validation.minLength && String(value).length < validation.minLength) {
		return validation.message || `${column} must be at least ${validation.minLength} characters`;
	}

	// Business logic validations
	if (column === 'age' && row.dob) {
		const calculatedAge = moment().diff(moment(row.dob, DATE_FORMAT.DD_MM_YYYY), 'years');
		const ageDiff = Math.abs(Number(value) - calculatedAge);
		if (ageDiff > 1) {
			return `Age (${value}) doesn't match with Date of Birth. Calculated age is ${calculatedAge}`;
		}
	}

	if (column === 'balance' && row.amount !== undefined && row.paid !== undefined) {
		const calculatedBalance = Number(row.amount) - Number(row.paid);
		if (Math.abs(Number(value) - calculatedBalance) > 0.01) {
			return `Balance should be ${calculatedBalance} (Amount - Paid)`;
		}
	}

	if (column === 'upiTransactionId' && row.paymentMethod === 'upi' && isEmpty) {
		return 'UPI Transaction ID is required when payment method is UPI';
	}

	return null;
};

// Group errors by row
export const getGroupedErrors = (validationErrors) => {
	const grouped = {};
	validationErrors.forEach((error) => {
		if (!grouped[error.row]) {
			grouped[error.row] = [];
		}
		grouped[error.row].push(error);
	});
	return grouped;
};
